import React from "react";
import { IconButton } from "../../../../../../ui-kit/IButton/IconButton/IconButton";
import moment from "moment";
import styles from "./Row.module.scss";
import nsi from "../../../../../../store/nsi";
import { toJS } from "mobx";

const convertDate = (timestamp: string) => {
  if (timestamp) {
    return moment(timestamp).format("DD.MM.YYYY");
  }
};

export const Row: React.FC = ({ row, handleItem, item }) => {
  return (
    <tr
      className={`${styles.row} ${item?.id === row?.id ? styles.active : ""}`}
    >
      <td>{row?.dictionaryValue}</td>
      <td>{convertDate(row?.installatioDate)}</td>
      <td>
        <div className={styles.action}>
          <IconButton
            typeIcon="edit"
            variant="text"
            className={styles.button}
            onClick={() => handleItem(row)}
          />
          <IconButton
            typeIcon="delete"
            variant="text"
            className={styles.button}
          />
        </div>
      </td>
    </tr>
  );
};
